import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { TabModel } from '@rush-shared/models'
import { RushMainService } from '@rush-shared/services/rush-main.service'
import { SvgIconComponent } from 'angular-svg-icon'

@Component({
  selector: 'app-tab',
  standalone: true,
  imports: [SvgIconComponent, CommonModule],
  templateUrl: './tab.component.html',
  styleUrl: './tab.component.sass',
})
export class TabComponent {
  private defaultFillColor = '!text-black !fill-black'
  private defaultBackground = 'bg-gradient-to-b from-white to-[#E9E3FF] text-black'

  @Input() tab: TabModel
  @Input() diabledTabSetting: boolean
  @Input() manualActive: boolean

  get isActive(): boolean {
    return this._rushMainService.isActiveTab(this.tab.name) || this.manualActive
  }

  constructor(private _rushMainService: RushMainService) {}

  onTabHover() {
    this.tab.hovered = !this.tab.hovered
  }

  onTabClick() {
    if (this.diabledTabSetting) {
      return
    }

    this._rushMainService.setActiveTab(this.tab)
  }

  svgClasses() {
    if (this.tab.hovered) {
      return '!text-black !fill-black'
    }

    if (this.isActive) {
      return this.defaultFillColor
    }

    return '!text-white !fill-white'
  }

  divClasses() {
    if (this.isActive || this.tab.hovered) {
      return this.defaultBackground
    }
    return '!bg-black !text-white !fill-white'
  }
}
